module.exports = __webpack_public_path__ + "static/img-5-0de430c1674d9bbc66126d6ca17d79a2.jpeg";